module.exports = __webpack_public_path__ + "static/img/5.572f90c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/sp/5.png
// module id = 4XLl
// module chunks = 0